import React from 'react';
import { IUCNStatusCode, iucnStatusData, isRedListCategory } from 'src/shared/helpers/iucnStatusHelper';
import { Status } from 'src/shared/types/status';
import classNames from 'classnames';
import StatusChip from '../status-chip/StatusChip';

export interface IUCNStatusChipProps {
    status: IUCNStatusCode;
    className?: string;
}

export const IUCNStatusChip: React.FC<IUCNStatusChipProps> = ({ status, className }) => {
    const statusInfo = iucnStatusData[status];

    if (!statusInfo) {
        return null;
    }

    // Only CR, EN, VU, NT should be red; others use default styling
    const isRedListStatus = isRedListCategory(status);

    const chipClassNames = classNames('max-w-fit', className);
    const statusLabel = statusInfo.label;
    return <StatusChip label={statusLabel} status={isRedListStatus ? Status.ERROR : Status.UNKNOWN} className={chipClassNames} />;
};

export default IUCNStatusChip;
